import React from "react";
import PropTypes from "prop-types";

import SolicitudForm from "./SolicitudForm";
import ModalSolicitud from "../components/ModalSolicitud";
import { Cargando, EstadoVacio } from "../components/Estados";

import { useConsulta } from "../hooks/useConsulta";
import { actualizarSolicitud, obtenerSolicitud } from "../services/bibliotecaApi";

/**
 * Edicion de una solicitud existente: trae su detalle y con el abre el mismo
 * formulario de crear. Los pasos, las reglas y la validacion son los de
 * siempre; lo unico que cambia es a donde se envia.
 *
 * El servidor vuelve a comprobar quien edita y en que estado esta: aunque la
 * pantalla solo muestre el boton cuando se puede, la regla no vive aqui.
 */
const EditarSolicitud = ({ id, usuario, onCerrar, onMensaje, onGuardada }) => {
  const { datos: solicitud, cargando, error } = useConsulta(
    () => obtenerSolicitud(id),
    [id],
    null,
  );

  // Mientras llega, o si no se puede abrir, se ve el mismo modal con el estado
  // en lugar de los pasos: editar nunca saca a nadie de la lista de Procesos.
  if (cargando || error || !solicitud) {
    return (
      <ModalSolicitud titulo="Editar solicitud" onCerrar={onCerrar}>
        {cargando ? (
          <Cargando />
        ) : (
          <EstadoVacio
            mensaje={error?.message ?? "No fue posible cargar la solicitud"}
          />
        )}
      </ModalSolicitud>
    );
  }

  const onGuardar = async (payload) => {
    const { ok, titulo, estado } = await actualizarSolicitud(id, payload);

    // 302 es una regla de negocio (ya no se puede editar, sin cupo...);
    // cualquier otro codigo, o ninguno, es una falla del servidor o de la red.
    const tipoMensaje = ok ? "success" : estado === 302 ? "info" : "error";
    onMensaje(titulo, tipoMensaje);

    if (ok) onGuardada();
    return ok;
  };

  const { codigo, nombre } = solicitud.tipo_solicitud ?? {};

  return (
    <SolicitudForm
      tipo={codigo}
      titulo={`Editar ${nombre ?? "solicitud"}`}
      usuario={usuario}
      solicitud={solicitud}
      onCerrar={onCerrar}
      onGuardar={onGuardar}
      onMensaje={onMensaje}
      // Reemplaza al modal de "cargando", que ya hizo la entrada.
      animarEntrada={false}
    />
  );
};

EditarSolicitud.propTypes = {
  id: PropTypes.number.isRequired,
  onCerrar: PropTypes.func.isRequired,
  // Se llama cuando los cambios quedaron guardados.
  onGuardada: PropTypes.func.isRequired,
  usuario: PropTypes.object,
  onMensaje: PropTypes.func,
};

EditarSolicitud.defaultProps = {
  onMensaje: () => {},
};

export default EditarSolicitud;
